import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FreeVideoListLayer from "../components/FreeVideoListLayer";
 
 
const FreeVideoListPage = () => {
  return (
    <>
 
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Free Videos  </h5><Breadcrumb title="Free Videos" /></div>
 
        <FreeVideoListLayer />
 
 
    </>
  );
};
 
export default FreeVideoListPage;
 
 